var map = {
	"./weddings1.jpg": 4601,
	"./weddings10.jpg": 229,
	"./weddings11.jpg": 2360,
	"./weddings2.jpg": 894,
	"./weddings3.jpg": 5675,
	"./weddings4.jpg": 3000,
	"./weddings5.jpg": 5365,
	"./weddings6.jpg": 2762,
	"./weddings7.jpg": 7223,
	"./weddings8.jpg": 5860,
	"./weddings9.jpg": 3905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2926;